"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import format from "../../formatters/general";
import classNames from "classnames";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
export const validId = (id) => {
  return !!id && id !== "";
};
function keyPressNotifier(event, lineItem, action) {
  if (event.charCode === 13) {
    action();
  }
}
function typeWarning(state) {
  if (!validId(state.tms_line_item_type_id)) {
    return /* @__PURE__ */ jsx("small", { className: "error", children: "Please select type" });
  }
}
function possibleActions(props, lineItem) {
  if (!props.readOnly) {
    return /* @__PURE__ */ jsx("div", { className: "small-1 column line-items__actions", children: /* @__PURE__ */ jsx(
      "a",
      {
        onClick: props.removeItem(lineItem),
        className: "line-items__trash",
        title: "Delete item",
        children: /* @__PURE__ */ jsx("i", { className: "fi-trash" })
      }
    ) });
  } else {
    return /* @__PURE__ */ jsx("div", { className: "small-1 column line-items__actions" });
  }
}
function lineItemTypeOptions(props) {
  var _a;
  const empty = { id: "", description: "Select Type" };
  const types = [empty].concat(
    _.sortBy((_a = props.lineItemTypes) != null ? _a : [], "description")
  );
  return types.map((item) => /* @__PURE__ */ jsx("option", { value: item.id, children: item.description }, "item_option_" + item.id));
}
function lineItemFields(props, state) {
  const newState = {
    tms_line_item_type_id: props.lineItem.tms_line_item_type_id,
    description: props.lineItem.description,
    total: format.cleanAmount(props.lineItem.total)
  };
  if (newState.tms_line_item_type_id === state.tms_line_item_type_id && newState.description === state.description && state.editing) {
    newState.total = state.total;
  }
  return newState;
}
class LineItem extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", lineItemFields(this.props, {}));
    __publicField(this, "mounted", false);
    __publicField(this, "setupFields", (props) => {
      this.setState(lineItemFields(props, this.state));
    });
    __publicField(this, "changeDescription", (lineItem) => {
      return () => {
        this.changeField(this.state.description, "description", lineItem);
      };
    });
    __publicField(this, "changeField", (value, field, lineItem) => {
      this.setState({ updating: true, editing: false });
      this.props.updateItem(lineItem, field, value).then(() => {
        if (this.mounted) this.setState({ updating: false });
      });
    });
    __publicField(this, "changeTypeId", (lineItem) => {
      return (e) => {
        const newId = e.target.value;
        if (this.state.total) {
          lineItem.total = format.cleanAmount(this.state.total);
        }
        if (this.state.description) {
          lineItem.description = this.state.description;
        }
        this.changeField(newId, "tms_line_item_type_id", lineItem);
      };
    });
    __publicField(this, "changeTotal", (lineItem) => {
      return (e) => {
        let total = format.cleanAmount(this.state.total);
        if (total === null) {
          total = format.cleanAmount(0);
        }
        this.changeField(total, "total", lineItem);
      };
    });
    __publicField(this, "possibleDescriptionField", (lineItem) => {
      if (this.props.creatingLoad) {
        return /* @__PURE__ */ jsx("div", { className: "small-3 column", children: /* @__PURE__ */ jsx(
          ValueLinkTextDroppableInput,
          {
            type: "text",
            disabled: this.state.updating || this.props.readOnly,
            value: this.state.description,
            onValueChange: (description) => this.setState({ description }),
            onBlur: this.changeDescription(lineItem),
            onKeyPress: _.partial(
              keyPressNotifier,
              _,
              lineItem,
              this.changeDescription()
            ),
            inputDropped: this.changeDescription(lineItem),
            placeholder: "description",
            className: "line-item__description"
          }
        ) });
      }
    });
    __publicField(this, "amountField", (lineItem) => {
      const colClass = this.props.creatingLoad ? "small-2" : "small-4";
      return /* @__PURE__ */ jsx("div", { className: "column " + colClass, children: /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
        /* @__PURE__ */ jsx("div", { className: "small-2 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
        /* @__PURE__ */ jsx("div", { className: "small-8 columns", children: /* @__PURE__ */ jsx(
          ValueLinkTextDroppableInput,
          {
            type: "text",
            disabled: this.state.updating || this.props.readOnly,
            value: this.state.total,
            onValueChange: (total) => this.setState({ total }),
            onFocus: this.setEditing,
            onBlur: this.changeTotal(lineItem),
            onKeyPress: _.partial(
              keyPressNotifier,
              _,
              lineItem,
              this.changeTotal()
            ),
            inputDropped: this.changeTotal(lineItem),
            placeholder: "amount"
          }
        ) })
      ] }) });
    });
    __publicField(this, "setEditing", () => {
      this.setState({ editing: true });
    });
    __publicField(this, "typeSelector", (lineItem) => {
      const selectClasses = classNames({
        "small-4": this.props.creatingLoad,
        "small-5": !this.props.creatingLoad,
        column: true,
        error: !validId(this.state.tms_line_item_type_id)
      });
      return /* @__PURE__ */ jsxs("div", { className: selectClasses, children: [
        /* @__PURE__ */ jsx(
          "select",
          {
            type: "text",
            placeholder: "Description",
            value: this.state.tms_line_item_type_id,
            onChange: this.changeTypeId(lineItem),
            disabled: this.state.updating || this.props.readOnly,
            children: lineItemTypeOptions(this.props)
          }
        ),
        typeWarning(this.state)
      ] });
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentWillReceiveProps(newProps) {
    if (newProps !== this.props) {
      this.setupFields(newProps);
    }
  }
  render() {
    const lineItem = this.props.lineItem;
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "LineItem",
        className: "small-10 column line-items__line-item",
        children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
          this.typeSelector(lineItem),
          this.possibleDescriptionField(lineItem),
          this.amountField(lineItem),
          possibleActions(this.props, lineItem)
        ] })
      }
    );
  }
}
export default LineItem;
